
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"30","cy":"30","r":"30","fill":"#252525"}}),_c('g',{attrs:{"stroke":"#FFF","transform":"translate(13 13)"}},[_c('circle',{attrs:{"cx":"17","cy":"17","r":"16.5"}}),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M20.624 16.78l-5.295-3.63c-.566-.389-1.329.024-1.329.72v7.26c0 .696.763 1.109 1.329.72l5.295-3.63a.878.878 0 000-1.44zM6.65 12.734c.952-2.585 2.678-4.573 4.7-5.468m-1.562 5.596c.391-.76.89-1.36 1.424-1.724"}})])])])
      }
    
      }
    